import { APICore } from './apiCore';
import { apiBaseUrl } from '../../constants';

const api = new APICore();

function apiAdminSendGlobalMessage(message: string) {
    return api.create(`${apiBaseUrl}/global-message`, { message });
}
export { apiAdminSendGlobalMessage };
